// scripts/build-media.mjs tarafından üretildi — elle düzenlemeyin.
// Yeniden üretmek için: npm run media

export type MediaEntry = {
  /** public/ altındaki çıktı klasörü */
  dir: string;
  slug: string;
  /** üretilmiş genişlikler, küçükten büyüğe */
  widths: number[];
  /** genişlik / yükseklik */
  aspect: number;
};

export const MEDIA: Record<string, MediaEntry> = {
  "gallery/antre-01": {
    "dir": "img/gallery",
    "slug": "antre-01",
    "widths": [
      600,
      1200
    ],
    "aspect": 1.3201
  },
  "gallery/antre-02": {
    "dir": "img/gallery",
    "slug": "antre-02",
    "widths": [
      600,
      1200
    ],
    "aspect": 1.318
  },
  "gallery/antre-03": {
    "dir": "img/gallery",
    "slug": "antre-03",
    "widths": [
      600,
      1200
    ],
    "aspect": 1.1176
  },
  "gallery/antre-04": {
    "dir": "img/gallery",
    "slug": "antre-04",
    "widths": [
      600,
      1200
    ],
    "aspect": 1.3548
  },
  "gallery/banyo-01": {
    "dir": "img/gallery",
    "slug": "banyo-01",
    "widths": [
      600
    ],
    "aspect": 0.5102
  },
  "gallery/banyo-02": {
    "dir": "img/gallery",
    "slug": "banyo-02",
    "widths": [
      600
    ],
    "aspect": 0.5102
  },
  "gallery/banyo-03": {
    "dir": "img/gallery",
    "slug": "banyo-03",
    "widths": [
      600
    ],
    "aspect": 0.5281
  },
  "gallery/banyo-04": {
    "dir": "img/gallery",
    "slug": "banyo-04",
    "widths": [
      600,
      1200
    ],
    "aspect": 1.148
  },
  "gallery/banyo-05": {
    "dir": "img/gallery",
    "slug": "banyo-05",
    "widths": [
      600
    ],
    "aspect": 0.7805
  },
  "gallery/banyo-06": {
    "dir": "img/gallery",
    "slug": "banyo-06",
    "widths": [
      600
    ],
    "aspect": 0.5363
  },
  "gallery/banyo-07": {
    "dir": "img/gallery",
    "slug": "banyo-07",
    "widths": [
      600
    ],
    "aspect": 0.6031
  },
  "gallery/banyo-08": {
    "dir": "img/gallery",
    "slug": "banyo-08",
    "widths": [
      600,
      1200
    ],
    "aspect": 0.9969
  },
  "gallery/banyo-09": {
    "dir": "img/gallery",
    "slug": "banyo-09",
    "widths": [
      600
    ],
    "aspect": 0.5262
  },
  "gallery/cocuk-odasi-01": {
    "dir": "img/gallery",
    "slug": "cocuk-odasi-01",
    "widths": [
      600,
      1200
    ],
    "aspect": 1.581
  },
  "gallery/cocuk-odasi-02": {
    "dir": "img/gallery",
    "slug": "cocuk-odasi-02",
    "widths": [
      600,
      1200
    ],
    "aspect": 1.6931
  },
  "gallery/cocuk-odasi-03": {
    "dir": "img/gallery",
    "slug": "cocuk-odasi-03",
    "widths": [
      600,
      1200
    ],
    "aspect": 1.5779
  },
  "gallery/cocuk-odasi-04": {
    "dir": "img/gallery",
    "slug": "cocuk-odasi-04",
    "widths": [
      600,
      1200
    ],
    "aspect": 1.5952
  },
  "gallery/dis-cephe-gece-01": {
    "dir": "img/gallery",
    "slug": "dis-cephe-gece-01",
    "widths": [
      600,
      1200,
      2000
    ],
    "aspect": 1.6667
  },
  "gallery/dis-cephe-gece-02": {
    "dir": "img/gallery",
    "slug": "dis-cephe-gece-02",
    "widths": [
      600,
      1200,
      2000
    ],
    "aspect": 1.6667
  },
  "gallery/dis-cephe-gece-03": {
    "dir": "img/gallery",
    "slug": "dis-cephe-gece-03",
    "widths": [
      600,
      1200,
      2000
    ],
    "aspect": 1.6667
  },
  "gallery/dis-cephe-gece-04": {
    "dir": "img/gallery",
    "slug": "dis-cephe-gece-04",
    "widths": [
      600,
      1200,
      2000
    ],
    "aspect": 1.6667
  },
  "gallery/dis-cephe-gunduz-01": {
    "dir": "img/gallery",
    "slug": "dis-cephe-gunduz-01",
    "widths": [
      600,
      1200,
      2000
    ],
    "aspect": 1.6667
  },
  "gallery/dis-cephe-gunduz-02": {
    "dir": "img/gallery",
    "slug": "dis-cephe-gunduz-02",
    "widths": [
      600,
      1200,
      2000
    ],
    "aspect": 1.6667
  },
  "gallery/dis-cephe-gunduz-03": {
    "dir": "img/gallery",
    "slug": "dis-cephe-gunduz-03",
    "widths": [
      600,
      1200,
      2000
    ],
    "aspect": 1.6667
  },
  "gallery/dis-cephe-gunduz-04": {
    "dir": "img/gallery",
    "slug": "dis-cephe-gunduz-04",
    "widths": [
      600,
      1200,
      2000
    ],
    "aspect": 1.6667
  },
  "gallery/giyinme-odasi-01": {
    "dir": "img/gallery",
    "slug": "giyinme-odasi-01",
    "widths": [
      600,
      1200
    ],
    "aspect": 1
  },
  "gallery/giyinme-odasi-02": {
    "dir": "img/gallery",
    "slug": "giyinme-odasi-02",
    "widths": [
      600,
      1200
    ],
    "aspect": 1
  },
  "gallery/giyinme-odasi-03": {
    "dir": "img/gallery",
    "slug": "giyinme-odasi-03",
    "widths": [
      600,
      1200
    ],
    "aspect": 1
  },
  "gallery/mutfak-01": {
    "dir": "img/gallery",
    "slug": "mutfak-01",
    "widths": [
      600,
      1200
    ],
    "aspect": 0.9236
  },
  "gallery/mutfak-02": {
    "dir": "img/gallery",
    "slug": "mutfak-02",
    "widths": [
      600,
      1200
    ],
    "aspect": 1.6211
  },
  "gallery/mutfak-03": {
    "dir": "img/gallery",
    "slug": "mutfak-03",
    "widths": [
      600,
      1200
    ],
    "aspect": 1.4585
  },
  "gallery/mutfak-04": {
    "dir": "img/gallery",
    "slug": "mutfak-04",
    "widths": [
      600,
      1200
    ],
    "aspect": 1.4011
  },
  "gallery/mutfak-05": {
    "dir": "img/gallery",
    "slug": "mutfak-05",
    "widths": [
      600,
      1200
    ],
    "aspect": 1.3913
  },
  "gallery/salon-01": {
    "dir": "img/gallery",
    "slug": "salon-01",
    "widths": [
      600,
      1200
    ],
    "aspect": 1.7778
  },
  "gallery/salon-02": {
    "dir": "img/gallery",
    "slug": "salon-02",
    "widths": [
      600,
      1200
    ],
    "aspect": 1.7778
  },
  "gallery/salon-03": {
    "dir": "img/gallery",
    "slug": "salon-03",
    "widths": [
      600,
      1200
    ],
    "aspect": 1.7778
  },
  "gallery/salon-04": {
    "dir": "img/gallery",
    "slug": "salon-04",
    "widths": [
      600,
      1200
    ],
    "aspect": 1.7778
  },
  "gallery/salon-05": {
    "dir": "img/gallery",
    "slug": "salon-05",
    "widths": [
      600,
      1200,
      2000
    ],
    "aspect": 1.7643
  },
  "gallery/salon-06": {
    "dir": "img/gallery",
    "slug": "salon-06",
    "widths": [
      600,
      1200,
      2000
    ],
    "aspect": 1.7778
  },
  "gallery/salon-07": {
    "dir": "img/gallery",
    "slug": "salon-07",
    "widths": [
      600,
      1200,
      2000
    ],
    "aspect": 1.7778
  },
  "gallery/yatak-odasi-01": {
    "dir": "img/gallery",
    "slug": "yatak-odasi-01",
    "widths": [
      600,
      1200
    ],
    "aspect": 1.7778
  },
  "gallery/yatak-odasi-02": {
    "dir": "img/gallery",
    "slug": "yatak-odasi-02",
    "widths": [
      600,
      1200
    ],
    "aspect": 1.4363
  },
  "gallery/yatak-odasi-03": {
    "dir": "img/gallery",
    "slug": "yatak-odasi-03",
    "widths": [
      600,
      1200
    ],
    "aspect": 1.4363
  },
  "gallery/yatak-odasi-04": {
    "dir": "img/gallery",
    "slug": "yatak-odasi-04",
    "widths": [
      600,
      1200
    ],
    "aspect": 1.0695
  },
  "gallery/yatak-odasi-05": {
    "dir": "img/gallery",
    "slug": "yatak-odasi-05",
    "widths": [
      600,
      1200
    ],
    "aspect": 1.6145
  },
  "interior/bedroom-1": {
    "dir": "img/interior",
    "slug": "bedroom-1",
    "widths": [
      768,
      1280
    ],
    "aspect": 1.7778
  },
  "interior/hero-rainnova": {
    "dir": "img/interior",
    "slug": "hero-rainnova",
    "widths": [
      768,
      1280,
      1920
    ],
    "aspect": 1.6667
  },
  "interior/kitchen-1": {
    "dir": "img/interior",
    "slug": "kitchen-1",
    "widths": [
      768,
      1280
    ],
    "aspect": 0.9236
  },
  "interior/living-1": {
    "dir": "img/interior",
    "slug": "living-1",
    "widths": [
      768,
      1280
    ],
    "aspect": 1.7778
  },
  "interior/living-2": {
    "dir": "img/interior",
    "slug": "living-2",
    "widths": [
      768,
      1280
    ],
    "aspect": 1.7778
  },
  "plans/floor-plan-2plus1-bblok": {
    "dir": "img/plans",
    "slug": "floor-plan-2plus1-bblok",
    "widths": [
      800,
      1600
    ],
    "aspect": 1.4147
  },
  "plans/floor-plan-2plus1": {
    "dir": "img/plans",
    "slug": "floor-plan-2plus1",
    "widths": [
      800,
      1600
    ],
    "aspect": 1.4147
  },
  "plans/floor-plan-3plus1-ablok": {
    "dir": "img/plans",
    "slug": "floor-plan-3plus1-ablok",
    "widths": [
      800,
      1600
    ],
    "aspect": 1.4147
  },
  "plans/floor-plan-3plus1-main": {
    "dir": "img/plans",
    "slug": "floor-plan-3plus1-main",
    "widths": [
      800,
      1600
    ],
    "aspect": 1.4147
  },
  "logo/baran-dark": {
    "dir": "img/logo",
    "slug": "baran-dark",
    "widths": [
      300,
      600
    ],
    "aspect": 1.5
  },
  "logo/baran-light": {
    "dir": "img/logo",
    "slug": "baran-light",
    "widths": [
      300,
      600
    ],
    "aspect": 1.5
  },
  "hero/poster": {
    "dir": "img/hero",
    "slug": "poster",
    "widths": [
      768,
      1280,
      1920
    ],
    "aspect": 1.6667
  }
};

/** <source srcset> için: "/img/gallery/salon-01-600.webp 600w, ..." */
export function srcSet(key: string, ext: 'avif' | 'webp'): string {
  const m = MEDIA[key];
  if (!m) throw new Error(`Bilinmeyen medya anahtarı: ${key}`);
  return m.widths.map((w) => `/${m.dir}/${m.slug}-${w}.${ext} ${w}w`).join(', ');
}

/** <img src> için geri düşüş — en büyük webp */
export function fallbackSrc(key: string): string {
  const m = MEDIA[key];
  if (!m) throw new Error(`Bilinmeyen medya anahtarı: ${key}`);
  return `/${m.dir}/${m.slug}-${m.widths[m.widths.length - 1]}.webp`;
}

/** CLS'i önlemek için explicit width/height */
export function dimensions(key: string, width: number): { width: number; height: number } {
  const m = MEDIA[key];
  if (!m) throw new Error(`Bilinmeyen medya anahtarı: ${key}`);
  return { width, height: Math.round(width / m.aspect) };
}
